module.exports = __webpack_public_path__ + "img/HCS.62cf2123.png";